import clsx from 'clsx';
import React from 'react';

import IconError from '../Images/Rebranding/IconError';

interface FieldErrorProps {
  children: React.ReactNode;
  className?: string;
}

const FieldError = ({ children, className }: FieldErrorProps) => {
  return (
    <div
      className={clsx(
        'mt-8 flex items-center font-suisse-screen text-disclosure-sm text-primary-magenta',
        className
      )}
    >
      <IconError className="mr-8 w-[15px]" />
      {children}
    </div>
  );
};

export default FieldError;
